import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action, observable, computed, autorun } from 'mobx';
import moment from 'moment';
//import BigCalendar from 'react-big-calendar';

import { Tabs } from '../component/Tabs';

import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';
import { DayPickerRange } from '../component/DayPicker';
import { DayPicker } from '../component/DayPicker';

import { BWStepBar } from '../component/BWStepBar';
import { BWReceipt } from '../component/BWReceipt';

import { TimePicker } from '../component/TimePicker';
import { Dropdown } from '../component/Dropdown';

import { WeekCalendar } from '../component/DayPicker';

import { AllotmentCalendar } from '../component/AllotmentCalendar';
import { AllotmentCalendarMonth } from '../component/AllotmentCalendarMonth';

import { isDesktop } from '../../model/deviceInfo';

import translateBase from '../../translate';
import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime, fmtTimeHrs, fmtTimeMins } from '../../model/formatters';

let tw = 0;

function momentMin(a, b) {
  let ma = moment(a);
  let mb = moment(b);
  if (ma.isBefore(mb)) return ma;
  return mb;
}

function momentMax(a, b) {
  let ma = moment(a);
  let mb = moment(b);
  if (ma.isBefore(mb)) return mb;
  return ma;
}


@inject(stores => ({
  navigation: stores.app.navigation,
  vOfferDetails: stores.app.vOfferDetails,
  offerDetailsForm: stores.app.offerDetailsForm,
  rentalTransaction: stores.app.rentalTransaction,
  bestOffers: stores.app.bestOffers,
  vBookingWizard: stores.app.vBookingWizard,
  allotmentDetails: stores.app.allotmentDetails,
  rentalObject: stores.app.rentalObject,
  businessUnit: stores.app.businessUnit,
  //navigation: stores.app.navigation,
}))
@observer
export class BWOfferDetails extends React.Component {

  constructor(props) {
    super(props);
  }

  // TODO: Refactor - copy pasted to step bar
  @computed get nextStepEnabled() {
    return this.props.rentalTransaction.mainObjectOffers.length > 0 && !this.props.offerDetailsForm.canApplyNewValues;
  }

  getNextActionLink() {
    const { navigation } = this.props;
    switch (this.props.vBookingWizard.nextOfferDetailsAction) {
      case "Services":
        return <a id="btn-fwd-bwoffer" className={"forward" + (this.nextStepEnabled ? "" : " disabled")}
          onClick={this.nextStepEnabled && navigation.goBWServices}>{this.translate("next", "Weiter")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
      case "Accessories":
        return <a id="btn-fwd-bwoffer" className={"forward" + (this.nextStepEnabled ? "" : " disabled")}
          onClick={this.nextStepEnabled && navigation.goBWAccessories}>{this.translate("next", "Weiter")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
      case "PersonalData":
        return <a id="btn-fwd-bwoffer" className={"forward" + (this.nextStepEnabled ? "" : " disabled")}
          onClick={this.nextStepEnabled && navigation.goBWPersonalData}>{this.translate("next", "Weiter")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
    }
  }

  @computed get selectionStart() {
    return this.props.offerDetailsForm.newStartDate
  }

  @computed get selectionEnd() {
    return this.props.offerDetailsForm.newEndDate
  }

  @action.bound changeViewType() {
    this.props.vOfferDetails.changeViewType();
  }

  @action.bound handleDayMouseOver(date) {
    if (this.selectsEndDate) {
      this.endDateByStep = moment(date);//.add({days: 1});
    }
  }

  @action.bound selectionChanged({ start, end }) {
    this.props.vOfferDetails.setSelection({ start, end });
    isDesktop && this.props.offerDetailsForm.applyNewValues();
  }

  @observable selectsEndDate = false;
  @observable.ref startDateByStep = null;
  @observable.ref endDateByStep = null;

  @action.bound handleOutsideClick() {
    this.selectsEndDate = false;
  }

  @action.bound intervalSelected({ start, end }) {
    /*if(isDesktop && this.props.allotmentDetails.calendarView === 'month') {
      if(!this.selectsEndDate) {
        if(end.diff(start, 'hours') <= 24) {
          this.selectsEndDate = true;
          this.startDateByStep = moment(start);
          this.endDateByStep = moment(end);
          return;
        }
      } else {
        let t0 = moment(this.startDateByStep)
        let t1 =  moment(this.endDateByStep);
        this.props.vOfferDetails.setSelection({
          start: momentMin(t0, t1), 
          end: momentMax(t0, t1),
        });
        isDesktop && this.props.offerDetailsForm.applyNewValues();
        this.selectsEndDate = false;
        return;
      }
    }*/
    console.log(`Calendar says: Select new interval [${moment(start).format('YYYY-MM-DD HH:mm')}, ${moment(end).format('YYYY-MM-DD HH:mm')}].`)
    this.selectsEndDate = false;
    this.props.vOfferDetails.setSelection({ start, end });
    isDesktop && this.props.offerDetailsForm.applyNewValues();
  }


  render() {
    let translate = translateBase.bindPage('bw01OfferDetails');
    this.translate = translate;
    const { navigation, offerDetailsForm, rentalTransaction, bestOffers, vOfferDetails, allotmentDetails, businessUnit, rentalObject } = this.props;
    const currency = businessUnit.currencyName; //"CHF";
    return (
      <div>
        <SiteHeader />

        <BWStepBar activeStep={1} />

        <BWReceipt />

        <section className="wizard-container booking-view">
          <div className="wrapper">

            <div className="row wizard-content">
              <div className="column-12">
                <h3 className="mali-blue">{translate("bookingDates", "Buchungsdaten")}</h3>
              </div>
            </div>

            <div className="row selectDates-container" /*style={{display: 'block'}}*/>
              <div className="explain-text">
                <h4>{translate("instructionsTitle1", "Anleitung")}</h4>
                <p>{translate("instructionsText1", "Passen Sie bei Bedarf die Start- und Endzeiten an. Beachten Sie, dass das System Ihre Angaben automatisch korrigieren kann um die Buchungsregeln des Vermieters zu berücksichtigen.")}</p>
              </div>
              <div className="column-6">
                <div className="label">{translate("startDate", "Startzeit")}</div>
                <Dropdown>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
                  offerDetailsForm.newStartDate ? <div ref={ref} className="selectDate date-field from">
                    <div className="date-input" onClick={onOpen}>{fmtDate(offerDetailsForm.newStartDate)}</div>
                    <div className={"dropdown calender" + (isOpen ? ' active' : '')}>
                      <DayPicker
                        onDayClick={(day) => { offerDetailsForm.setStartDateOnly(day); onClose(); }}
                        selectedDays={new Date(offerDetailsForm.newStartDate)}
                        month={new Date(offerDetailsForm.newStartDate)}
                      />
                    </div>
                  </div>
                    : null
                }</Observer>}</Dropdown>
                {/*
                <div className="selectDate time-field from">
                    {vOfferDetails.displayElements.hours && <div>
                      <input readOnly value={offerDetailsForm.newStartHours} onClick={() => {}}/>
                      <a className="minus" onClick={() => offerDetailsForm.decStartHours(1)}><i className="fa fa-minus"></i></a>
                      <a className="plus" onClick={() => offerDetailsForm.incStartHours(1)}><i className="fa fa-plus"></i></a>                  
                    </div>}
                </div>
                <div className="selectDate time-field from">
                    {vOfferDetails.displayElements.minutes && <div>
                      <input readOnly value={offerDetailsForm.newStartMinutes} onClick={() => {}}/>
                      <a className="minus test-minutes-from" onClick={() => offerDetailsForm.decStartMinutes(vOfferDetails.displayElements.minus.minutes)}><i className="fa fa-minus"></i></a>
                      <a className="plus test-minutes-from" onClick={() => offerDetailsForm.incStartMinutes(vOfferDetails.displayElements.plus.minutes)}><i className="fa fa-plus"></i></a>                                      
                    </div>}
                </div>
*/}
                <div className={"selectDate time-field from "+(vOfferDetails.displayElements.hours && vOfferDetails.displayElements.minutes ? 'hoursMins' : 'hoursOnly')}>
                  {vOfferDetails.displayElements.hours && (
                    !vOfferDetails.displayElements.minutes ?
                      <div>
                        <input readOnly value={fmtTime(offerDetailsForm.newStartDate)} onClick={() => { }} />
                        <a className="minus" onClick={() => offerDetailsForm.decStartHours(1)}><i className="fa fa-minus"></i></a>
                        <a className="plus" onClick={() => offerDetailsForm.incStartHours(1)}><i className="fa fa-plus"></i></a>
                      </div>
                      :
                      <div>
                        <div className="hours">
                          <input readOnly value={fmtTimeHrs(offerDetailsForm.newStartDate)} onClick={() => { }} />
                          <a className="minus test-minutes-from" onClick={() => offerDetailsForm.decStartTime(60)}><i className="fa fa-minus"></i></a>
                          <a className="plus test-minutes-from" onClick={() => offerDetailsForm.incStartTime(60)}><i className="fa fa-plus"></i></a>
                        </div>
                        <div className="minutes">
                          <input readOnly value={fmtTimeMins(offerDetailsForm.newStartDate)} onClick={() => { }} />
                          <a className="minus test-minutes-from" onClick={() => offerDetailsForm.decStartTime(vOfferDetails.displayElements.minus.minutes)}><i className="fa fa-minus"></i></a>
                          <a className="plus test-minutes-from" onClick={() => offerDetailsForm.incStartTime(vOfferDetails.displayElements.plus.minutes)}><i className="fa fa-plus"></i></a>
                        </div>
                      </div>
                  )}
                </div>
              </div>
              <div className="column-6">
                <div className="label">{translate("endDate", "Endzeit")}</div>
                <Dropdown>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
                  offerDetailsForm.newEndDate ? <div ref={ref} className="selectDate date-field to">
                    <div className="date-input" onClick={onOpen}>{fmtDate(offerDetailsForm.newEndDate)}</div>
                    <div className={"dropdown calender" + (isOpen ? ' active' : '')}>
                      <DayPicker
                        onDayClick={(day) => { offerDetailsForm.setEndDateOnly(day); onClose(); }}
                        selectedDays={new Date(offerDetailsForm.newEndDate)}
                        month={new Date(offerDetailsForm.newEndDate)}
                      />
                    </div>
                  </div>
                    : null
                }</Observer>}</Dropdown>
                {/*
                <div className="selectDate time-field to">
                    {vOfferDetails.displayElements.hours && <div>
                      <input readOnly value={offerDetailsForm.newEndHours} onClick={() => {}}/>
                      <a className="minus" onClick={() => offerDetailsForm.decEndHours(1)}><i className="fa fa-minus"></i></a>
                      <a className="plus" onClick={() => offerDetailsForm.incEndHours(1)}><i className="fa fa-plus"></i></a>  
                    </div>}
                </div>

                <div className="selectDate time-field to">      
                    {vOfferDetails.displayElements.minutes && <div>
                      <input readOnly value={offerDetailsForm.newEndMinutes} onClick={() => {}}/>
                      <a className="minus" onClick={() => offerDetailsForm.decEndMinutes(vOfferDetails.displayElements.minus.minutes)}><i className="fa fa-minus"></i></a>
                      <a className="plus" onClick={() => offerDetailsForm.incEndMinutes(vOfferDetails.displayElements.plus.minutes)}><i className="fa fa-plus"></i></a>                                      
                    </div>}
                </div>
*/}

                <div className={"selectDate time-field to "+(vOfferDetails.displayElements.hours && vOfferDetails.displayElements.minutes ? 'hoursMins' : 'hoursOnly')}>
                  {vOfferDetails.displayElements.hours && (
                    !vOfferDetails.displayElements.minutes ?
                      <div>
                        <input readOnly value={fmtTime(offerDetailsForm.newEndDate)} onClick={() => { }} />
                        <a className="minus" onClick={() => offerDetailsForm.decEndHours(1)}><i className="fa fa-minus"></i></a>
                        <a className="plus" onClick={() => offerDetailsForm.incEndHours(1)}><i className="fa fa-plus"></i></a>
                      </div>
                      :
                      <div>
                        <div className="hours">
                          <input readOnly value={fmtTimeHrs(offerDetailsForm.newEndDate)} onClick={() => { }} />
                          <a className="minus test-minutes-to" onClick={() => offerDetailsForm.decEndTime(60)}><i className="fa fa-minus"></i></a>
                          <a className="plus test-minutes-to" onClick={() => offerDetailsForm.incEndTime(60)}><i className="fa fa-plus"></i></a>
                        </div>
                        <div className="minutes">
                          <input readOnly value={fmtTimeMins(offerDetailsForm.newEndDate)} onClick={() => { }} />
                          <a className="minus test-minutes-to" onClick={() => offerDetailsForm.decEndTime(vOfferDetails.displayElements.minus.minutes)}><i className="fa fa-minus"></i></a>
                          <a className="plus test-minutes-to" onClick={() => offerDetailsForm.incEndTime(vOfferDetails.displayElements.plus.minutes)}><i className="fa fa-plus"></i></a>
                        </div>
                      </div>
                  )}
                </div>
              </div>
              <div className={"column-12 selectDateBtn" + (offerDetailsForm.canApplyNewValues ? "" : " disabled")}>
                <button id="btn-apply-datetime" onClick={() => { if (offerDetailsForm.canApplyNewValues) { 
                  offerDetailsForm.applyNewValues(); 
                  vOfferDetails.goSelection(); 
                }}}>{translate("applyNewValues", "Übernehmen")}</button>
              </div>
            </div>

            <div className="row calender-container">
              <div className="column-12">
                <div className="product-calendar wizard">
                  <div className="calendar-btns">
                    <button onClick={event => { allotmentDetails.goPrevFast(event); event.stopPropagation(); }}>
                      <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                    </button>
                    <button onClick={event => { allotmentDetails.goPrev(event); event.stopPropagation(); }}><i className="fa fa-chevron-left" aria-hidden="true"></i></button>
                    <button onClick={event => { this.changeViewType(event); }}>
                      {allotmentDetails.calendarView === "month" ? translate("weekView", "Wochenansicht") : translate("monthView", "Monatsansicht")}
                    </button>

                    <button id="btn-your-choice" onClick={event => { vOfferDetails.goSelection(event); event.stopPropagation(); }}>{translate("yourChoice", "Ihre Auswahl")}</button>
                    <button onClick={event => { allotmentDetails.goNext(event); event.stopPropagation(); }}><i className="fa fa-chevron-right" aria-hidden="true"></i></button>
                    <button onClick={event => { allotmentDetails.goNextFast(event); event.stopPropagation(); }}>
                      <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                    </button>
                  </div>
                  <Observer>{() => <div className="calendar-main">
                    {allotmentDetails.calendarView !== 'month' ?
                      <AllotmentCalendar
                        //selectableAllotment={isDesktop}
                        //movableAllotment={isDesktop}
                        selectableAllotment={false}
                        movableAllotment={false}
                        observables={observable({
                          /*selection: {
                            start: computed(() => moment(this.selectionStart)),
                            end: computed(() => moment(this.selectionEnd)),
                          },*/
                          selected: {
                            start: computed(() => moment(rentalTransaction.rentingStartDate)),
                            end: computed(() => moment(rentalTransaction.rentingEndDate)),
                          },
                          updtItems: computed(() => allotmentDetails.updtItems),
                          alreadyRentItems: computed(() => allotmentDetails.alreadyRentItems),
                          defaultView: computed(() => allotmentDetails.calendarView),
                          defaultDate: computed(() => allotmentDetails.calendarDefaultDate),
                        })}
                        onSelectionChanged={this.selectionChanged}
                        onIntervalSelect={this.intervalSelected}
                        onDayMouseOver={this.handleDayMouseOver}
                        onOutsideClick={this.handleOutsideClick}
                      />
                      :
                      <AllotmentCalendarMonth
                        //selectableAllotment={isDesktop}
                        selectableAllotment={false}
                        defaultDate={allotmentDetails.calendarDefaultDate}
                        unavailable={allotmentDetails.alreadyRentItems}
                        updt={allotmentDetails.updtItems}
                        selected={{
                          start: moment(rentalTransaction.rentingStartDate),
                          end: moment(rentalTransaction.rentingEndDate),
                        }}
                        /*selection={{
                          start: moment(this.selectionStart),
                          end: moment(this.selectionEnd),
                        }}*/
                        onIntervalSelected={this.intervalSelected}
                      />
                    }
                  </div>}</Observer>
                  {/*<div className="calendar-btns">
                    <button onClick={event => {allotmentDetails.goPrevFast(event); event.stopPropagation();}}>
                      <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                    </button>
                    <button onClick={event => {allotmentDetails.goPrev(event); event.stopPropagation();}}><i className="fa fa-chevron-left" aria-hidden="true"></i></button>
                    <button onClick={event => {this.changeViewType(event);}}>
                      {allotmentDetails.calendarView === "month" ? translate("weekView", "Wochenansicht") : translate("monthView", "Monatsansicht")}
                    </button>

                    <button onClick={event => {vOfferDetails.goSelection(event); event.stopPropagation();}}>{translate("yourChoice", "Ihre Auswahl")}</button>
                    <button onClick={event => {allotmentDetails.goNext(event); event.stopPropagation();}}><i className="fa fa-chevron-right" aria-hidden="true"></i></button>
                    <button onClick={event => {allotmentDetails.goNextFast(event); event.stopPropagation();}}>
                      <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                    </button>
                  </div>                     
                  <div className="calendar-main">               
                    <AllotmentCalendarMonth 
                      defaultDate={allotmentDetails.calendarDefaultDate}
                      unavailable={allotmentDetails.alreadyRentItems}
                      updt={allotmentDetails.updtItems}
                      selected={{
                        start: moment(rentalTransaction.rentingStartDate),
                        end: moment(rentalTransaction.rentingEndDate),
                      }}
                      selection={{
                        start: moment(this.selectionStart),
                        end: moment(this.selectionEnd),
                      }}
                      onIntervalSelected={this.intervalSelected}
                    />
                    </div>*/}
                  <div className="calendar-infos">
                    <div className="calendar-legend">
                      <h4>Legende</h4>
                      {/*<div className="legend-row selected-booking">
                        <div className="legend-color"></div>
                        <div className="legend-label">{translate("yourChoice", "Ihre Auswahl")}</div>
                      </div>*/}
                      <div className="legend-row actual-booking">
                        <div className="legend-color"></div>
                        <div className="legend-label">{translate("yourBooking", "Ihre Buchung")}</div>
                      </div>
                      <div className="legend-row booked">
                        <div className="legend-color"></div>
                        <div className="legend-label">{translate("notAvailable", "Nicht verfügbar")}</div>
                      </div>
                      {
                        rentalObject.organization.showSchedulesInBW ?
                          <div className="legend-row pickup-drop">
                            <div className="legend-color"></div>
                            <div className="legend-label">{translate("pickupDrop", "Übernahme- & Rückgabezeiten")}</div>
                          </div> 
                        : ''
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row main-wizardbtns-container">
              <div className="column-6">
                <a className="back" onClick={navigation.goObjectDetails}><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
              </div>
              <div className="column-6">
                {this.getNextActionLink()}
              </div>
            </div>

            {/*<div className="row">
                  <div className="column-3"></div>
                  <div className="column-6">
                    <div className="services-entry">
                            {vOfferDetails.displayElements.plus && 
                              vOfferDetails.displayElements.minus &&
                              <div>
                                <div className="list-entry selected">
                                    <div className="input">
                                      {rentalTransaction.rentingStartDate &&
                                        <span>Real offer start: {moment(rentalTransaction.rentingStartDate).format('DD.MM.YYYY  HH:mm')}</span>
                                      }
                                    </div>
                                    <div className="amount"> 
                                      <Dropdown>{({ref, isOpen, onOpen, onClose}) => <Observer>{() => 
                                        <div className="timepicker-dropdown" ref={ref}>                                     
                                          <input readOnly value={moment(offerDetailsForm.values.startDate).format('HH:mm')} onClick={onOpen}/>
                                          <a className="minus" onClick={() => offerDetailsForm.decStartTime(vOfferDetails.displayElements.minus.minutes)}><i className="fa fa-minus"></i></a>
                                          <a className="plus" onClick={() => offerDetailsForm.incStartTime(vOfferDetails.displayElements.plus.minutes)}><i className="fa fa-plus"></i></a>
                                          <TimePicker 
                                            hidden={!isOpen}
                                            hourBase={0} 
                                            hourStep={1} 
                                            minuteBase={0} 
                                            minuteStep={vOfferDetails.displayElements.plus.minutes} 
                                            value={offerDetailsForm.values.startDate} 
                                            onChange={mStartTime => {offerDetailsForm.setStartTimeOnly(mStartTime.toISOString()); onClose();}} />
                                        </div>
                                      }</Observer>}</Dropdown>
                                    </div>
                                </div>
                                <div className="list-entry selected">
                                    <div className="input">
                                      {rentalTransaction.rentingEndDate &&
                                        <span>Real offer end: {moment(rentalTransaction.rentingEndDate).format('DD.MM.YYYY HH:mm')}</span>
                                      }
                                    </div>                              
                                    <div className="amount">
                                      <Dropdown>{({ref, isOpen, onOpen, onClose}) => <Observer>{() => 
                                        <div className="timepicker-dropdown" ref={ref}>                                    
                                          <input readOnly value={moment(offerDetailsForm.values.endDate).format('HH:mm')} onClick={onOpen} />
                                          <a className="minus" onClick={() => offerDetailsForm.decEndTime(vOfferDetails.displayElements.minus.minutes)}><i className="fa fa-minus"></i></a>
                                          <a className="plus" onClick={() => offerDetailsForm.incEndTime(vOfferDetails.displayElements.plus.minutes)}><i className="fa fa-plus"></i></a>
                                          <TimePicker
                                            hidden={!isOpen} 
                                            hourBase={0} 
                                            hourStep={1} 
                                            minuteBase={0} 
                                            minuteStep={vOfferDetails.displayElements.plus.minutes} 
                                            value={offerDetailsForm.values.endDate} 
                                            onChange={mEndTime => {offerDetailsForm.setEndTimeOnly(mEndTime.toISOString()); onClose();}} />
                                        </div>
                                      }</Observer>}</Dropdown>
                                    </div>            
                                </div>
                                    </div>}
                    </div>  
                  </div>
                </div>*/}

            {/*<div className="row wizard-content">
                    <div className="column-12">
                        {rentalTransaction.mainObjectOffers.map(offer => {
                          return (
                            <div className="services-entry">
                                <div className="list-entry">
                                    <div className="input">{offer.name}</div>
                                    <div className="value">{currency} {offer.price}</div>
                                    <div className="price">{currency} {offer.price}</div>
                                </div>
                            </div>
                          )
                        })}

                    </div>
                  </div>*/}


          </div>
        </section>

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/BWOfferDetails.js